import landfundStillPreviewSrc1 from "public/addons/landfund/landfund-still-preview-1.jpg";
import landfundStillPreviewSrc2 from "public/addons/landfund/landfund-still-preview-2.jpg";

import { AddOnPromotionPage } from "../components/AddOnPromotionPage";
import { LANDFUND_ADDON } from "../constants";
import { landFundPrimaryActionHandler } from "../addOnActionHandlers";

export const LandFundPage = () => {
  return (
    <AddOnPromotionPage
      {...LANDFUND_ADDON}
      videoId="GobZWVKk3qA"
      videoTitle="LandFund - Tech-backed brokerage and appraisal tool"
      previewImages={[
        { src: landfundStillPreviewSrc1, alt: "Preview" },
        { src: landfundStillPreviewSrc2, alt: "Preview" },
      ]}
      onPrimaryActionClick={landFundPrimaryActionHandler}
      primaryActionText="View"
    />
  );
};
